import app from 'flarum/forum/app';
import Link from 'flarum/common/components/Link';
import username from 'flarum/common/helpers/username';
/**
 * Nome de usuário com link para o perfil. Autor apagado ou não carregado vira
 * texto simples: `app.route.user()` exige um registro real.
 */
export default function userLink(user) {
  if (!user) return username(user);
  return m(Link, {
    className: "ChatUserLink",
    href: app.route.user(user)
  }, username(user));
}
flarum.reg.add('ramon-chat', 'forum/utils/userLink', userLink);